import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { categoriesIconSource } from '../../../../images/assets';
import ItemIconsList from './ItemIconsList';
import NavButtons from './NavButtons';
import { jobCreationSteps } from '../../../../constants/jobs';

export default class PositionStep extends Component {
  static propTypes = {
    isPrivateParty: PropTypes.bool,
    jobCategories: PropTypes.array.isRequired,
    selectedCategoryId: PropTypes.number,
    jobSkillId: PropTypes.number,
    chooseCategory: PropTypes.func.isRequired,
    handleChangeSkill: PropTypes.func.isRequired,
    isFirstStepFilled: PropTypes.func.isRequired,
    goToStep: PropTypes.func.isRequired
  };

  render () {
    const { jobCategories, selectedCategoryId, jobSkillId, chooseCategory, handleChangeSkill, isFirstStepFilled, goToStep,
      isPrivateParty } = this.props;
    let skillsList = [];
    if (selectedCategoryId) {
      skillsList = jobCategories.find(category => category.id === selectedCategoryId).subcategory;
    }
    return (
      <React.Fragment>
        { !isPrivateParty && (
          <section className='job-posting-section skill-section'>
            <header><h4>I Need Help With ...</h4></header>
            <ItemIconsList
              listData={jobCategories}
              selectedItemId={selectedCategoryId}
              chooseItemHandler={chooseCategory}
              iconSource={categoriesIconSource}
              labelFieldName='category_label'
            />
          </section>
        )}
        { !!selectedCategoryId && (
          <React.Fragment>
            <section className='job-posting-section skill-section'>
              <header><h4>I Need a ...</h4></header>
              <ItemIconsList
                listData={skillsList}
                selectedItemId={jobSkillId}
                chooseItemHandler={handleChangeSkill}
                iconSourceFieldName='icon_url'
                labelFieldName='skill_label'
              />
            </section>
          </React.Fragment>
        )}
        <NavButtons
          showNextButton={isFirstStepFilled()}
          goToStep={goToStep}
          nextStepId={jobCreationSteps.second.id}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJob/PositionStep.js